// extracted by mini-css-extract-plugin
export default {"hr-desktop":"Base-module__hr-desktop__x5RDX","hr-mobile":"Base-module__hr-mobile__FBGvk"};